module.exports = "https://bin.bnbstatic.com/_next/static/images/submit-failed-8a5dd8a7257d9425f3928169226b94dc.svg";